/** Mensajes de error legibles para el usuario final (sin stack / códigos crudos). */

export function humanizeAccountingError(raw: unknown): string {
  const msg =
    typeof raw === 'string'
      ? raw
      : (raw as any)?.response?.data?.message ??
        (raw as any)?.message ??
        null;

  let text: string;
  if (msg == null) text = 'No se pudo completar la operación.';
  else if (typeof msg === 'string') text = msg;
  else if (typeof msg === 'object' && msg !== null && 'message' in msg) {
    text = String((msg as any).message);
  } else text = JSON.stringify(msg);

  // Strip common Nest envelope noise
  text = text.replace(/^Bad Request Exception:?\s*/i, '').trim();

  const lower = text.toLowerCase();
  if (
    lower.includes('agrupación') ||
    lower.includes('isposting') ||
    lower.includes('non-posting') ||
    lower.includes('grouping')
  ) {
    return 'No podés usar una cuenta de agrupación.';
  }
  if (lower.includes('forbidden') || lower.includes('403')) {
    return 'No tenés permiso para esta acción.';
  }
  if (lower.includes('unauthorized') || lower.includes('401')) {
    return 'Tu sesión expiró. Volvé a iniciar sesión.';
  }
  if (lower.includes('network') || lower.includes('econnrefused')) {
    return 'No hay conexión con el servidor. Reintentá en unos segundos.';
  }
  if (lower.includes('unique') || lower.includes('duplic')) {
    return 'Ya existe un registro con ese código.';
  }
  if (lower.includes('period') && (lower.includes('closed') || lower.includes('cerrad'))) {
    return 'El período está cerrado o bloqueado y no admite esta operación.';
  }
  // Avoid leaking Prisma / SQL
  if (lower.includes('prisma') || lower.includes('sql') || lower.includes('exception')) {
    return 'Ocurrió un error interno. Si persiste, contactá a soporte.';
  }
  return text;
}

export function errorTitleFor(raw: unknown): string {
  const status = (raw as any)?.response?.status;
  if (status === 403) return 'Sin permiso';
  if (status === 401) return 'Sesión inválida';
  if (status === 404) return 'No encontrado';
  if (status >= 500) return 'Error del servidor';
  return 'No se pudo completar';
}
